import React from 'react';
import { Link } from 'react-router-dom';
const RateUsComp = () => {
    return (
        <>
            <div>
                <div>
                    <div className='md:w-[50%] mt-6 md:py-16 mx-auto'>
                    <div className='mx-3'>
                        <h1 className='text-[#409BF5]   font-bold text-6xl text-center '>Rate your experience</h1>
                        <div className='  w-full py-7'>
                        <center>
                            <i class="fa-solid fa-star md:text-6xl text-4xl   text-[#dee4ea]"></i>
                            <i class="fa-solid fa-star md:text-6xl text-4xl   text-[#dee4ea]"></i>
                            <i class="fa-solid fa-star md:text-6xl text-4xl   text-[#dee4ea]"></i>
                            <i class="fa-solid fa-star md:text-6xl text-4xl   text-[#dee4ea]"></i>
                            <i class="fa-solid fa-star md:text-6xl text-4xl   text-[#dee4ea]"></i>

                            </center>
                        </div>
                        <div className=' md:px-10  '>
                             
                                <p className='py-4 text-xs text-[#131436]'>Please leave some words</p>
                                <textarea
      class="
        form-control block w-full px-3 rounded-3xl py-1.5   font-normal
        text-gray-600 bg-[#FBFEFF] text-xs bg-clip-padding border border-solid border-gray-300  
        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"id="exampleFormControlTextarea1" rows="8"
      placeholder="Enter here"></textarea>
    
                          
                        </div>

                 
                 <div className=' py-4 '>
                 <center>
            <Link to='/'>  <button className='mx-2 text-sm text-blue-500'> Return to Home</button></Link>
            <Link to="/Thanks" >  <button className='mx-2 text-xs bg-blue-400 text-gray-200 py-3 px-10 rounded-xl '> Give Rating</button></Link>
              </center>
            </div>

                    </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default RateUsComp